import type { ProviderListItemVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveProviders = createApiThunk<ProviderListItemVM[], void>(
  "providers/adminRetrieveProviders",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listProviders();
  },
);
